import {useMemo} from 'react';

import {type WorkspaceLayoutSettings} from '../../WorkspaceDrawer/Settings/types';
import {WORKSPACE_LAYOUT_TEMPLATE_FIELDS} from '../constants';
import {extractTemplateValues} from '../utils';
import {type WorkspaceTemplate} from '../workspaceTemplatesQueries';
import {WORKSPACE_LAYOUT_TEMPLATE_DISPLAY_FNS} from './displayFns';

export const useWorkspaceLayoutTemplateSections = ({
  currTemplateWorkspaceLayoutSettings,
  currWorkspaceLayoutSettings,
}: {
  currTemplateWorkspaceLayoutSettings: WorkspaceTemplate['workspaceLayoutSettings'];
  currWorkspaceLayoutSettings?: WorkspaceLayoutSettings;
}) => {
  return useMemo(() => {
    return [
      {
        title: 'Layout',
        rows: WORKSPACE_LAYOUT_TEMPLATE_FIELDS.map(key => {
          const displayFn = WORKSPACE_LAYOUT_TEMPLATE_DISPLAY_FNS[key];
          return displayFn({
            currTemplateWorkspaceLayoutSettings,
            currWorkspaceLayoutSettings,
          });
        }),
      },
    ];
  }, [currTemplateWorkspaceLayoutSettings, currWorkspaceLayoutSettings]);
};

/**
 * Extracts workspace layout values from a template to apply to workspace settings.
 */
export const getWorkspaceLayoutTemplateValues = (
  workspaceTemplate: WorkspaceTemplate | undefined
): WorkspaceLayoutSettings =>
  extractTemplateValues(
    workspaceTemplate?.workspaceLayoutSettings,
    WORKSPACE_LAYOUT_TEMPLATE_FIELDS
  );
